/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_New_Import_HintInputs */

const en_recipe_new_import_hint = /** @type {(inputs: Recipe_New_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check it, then mark as reviewed.`)
};

const de_recipe_new_import_hint = /** @type {(inputs: Recipe_New_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfe es und markiere es dann als geprüft.`)
};

/**
* | output |
* | --- |
* | "Check it, then mark as reviewed." |
*
* @param {Recipe_New_Import_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_new_import_hint = /** @type {((inputs?: Recipe_New_Import_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_New_Import_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_new_import_hint(inputs)
	return en_recipe_new_import_hint(inputs)
});